import React, { useEffect } from 'react';
import HeroCarousel from '../../components/sections/HeroCarousel';
import Footer from '../../components/common/Footer';
import './AdminPanel.module.css';
import AdminPanelHeader from '../../components/common/Header/AdminPanelHeader';
import WelcomeSection from '../../components/sections/WelcomeSection/WelcomeSection';

const AdminPanel = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="admin-panel-page">
      <AdminPanelHeader />
      <HeroCarousel />
      <WelcomeSection />
      <Footer />
    </div>
  );
};

export default AdminPanel;